import {
  AlertCircle,
  BadgeCheck,
  Banknote,
  CheckCircle2,
  ShieldCheck,
} from "lucide-react";

import jsPDF from "jspdf";
import "jspdf-autotable";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || analysisResult?.analysisData || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Final Evaluation Board Analysis Report", 40, yPos);
    yPos += 40;

    // Customer Master Profile
    doc.setFontSize(14);
    doc.text("Customer Master Profile", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Applicant Name: ${data.customerProfile?.name || data.applicant?.name || data.name || 'N/A'}`, 40, yPos);
    doc.text(`PAN: ${data.customerProfile?.pan || data.applicant?.pan || data.pan || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Aadhar: ${data.customerProfile?.aadhar || data.applicant?.aadhar || data.aadhar || 'N/A'}`, 40, yPos);
    doc.text(`DOB/Age: ${data.customerProfile?.dobAge || data.applicant?.dobAge || data.dobAge || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Contact Details: ${data.customerProfile?.contact || data.applicant?.phone || data.contact || 'N/A'}`, 40, yPos);
    doc.text(`Loan Type Applied: ${data.loanDetails?.loanType || data.application?.loanType || data.loanType || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Loan Amount Requested: Rs ${data.loanDetails?.requestedAmount || data.application?.amount || '0'}`, 40, yPos);
    doc.text(`Employment Type: ${data.customerProfile?.employmentType || data.applicant?.employmentType || data.employmentType || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Analysis Modules Overview
    doc.setFontSize(14);
    doc.text("Analysis Modules Overview", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Credit Bureau Analysis: ${data.analysisModules?.creditBureau?.value || 'N/A'} (${data.analysisModules?.creditBureau?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Bank Statement Analysis: ${data.analysisModules?.bankStatement?.value || 'N/A'} (${data.analysisModules?.bankStatement?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Income & ITR Analysis: ${data.analysisModules?.incomeItr?.value || 'N/A'} (${data.analysisModules?.incomeItr?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Employment Evaluation: ${data.analysisModules?.employment?.value || 'N/A'} (${data.analysisModules?.employment?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Business Profile Analysis: ${data.analysisModules?.businessProfile?.value || 'N/A'} (${data.analysisModules?.businessProfile?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Loan Statement Analysis: ${data.analysisModules?.loanStatement?.value || 'N/A'} (${data.analysisModules?.loanStatement?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Property & Legal Documents: ${data.analysisModules?.propertyLegal?.value || 'N/A'} (${data.analysisModules?.propertyLegal?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Registrations & Licenses: ${data.analysisModules?.registrations?.value || 'N/A'} (${data.analysisModules?.registrations?.status || 'N/A'})`, 40, yPos);
    yPos += 15;
    doc.text(`Agreements & Letters: ${data.analysisModules?.agreements?.value || 'N/A'} (${data.analysisModules?.agreements?.status || 'N/A'})`, 40, yPos);
    yPos += 30;

    // Final Scoring Dashboard
    doc.setFontSize(14);
    doc.text("Final Scoring Dashboard", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Credit Score Band: ${data.finalScoring?.creditScoreBand || 'N/A'}`, 40, yPos);
    doc.text(`Business Viability: ${data.finalScoring?.businessViability || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`EMI-to-Income Ratio: ${data.finalScoring?.emiToIncomeRatio || 'N/A'}`, 40, yPos);
    doc.text(`Property Title Clarity: ${data.finalScoring?.propertyTitleClarity || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Income Stability: ${data.finalScoring?.incomeStability || 'N/A'}`, 40, yPos);
    doc.text(`Registration & Compliance: ${data.finalScoring?.registrationCompliance || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Banking Pattern: ${data.finalScoring?.bankingPattern || 'N/A'}`, 40, yPos);
    doc.text(`Document Completeness: ${data.finalScoring?.documentCompleteness || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Financial Summary
    doc.setFontSize(14);
    doc.text("Financial Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Monthly Net Income: Rs ${data.financialSummary?.monthlyNetIncome || 'N/A'}`, 40, yPos);
    doc.text(`Proposed EMI: Rs ${data.financialSummary?.proposedEmi || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`EMI to Income Ratio: ${data.financialSummary?.emiToIncomeRatio || 'N/A'}`, 40, yPos);
    doc.text(`Surplus Income: Rs ${data.financialSummary?.surplusIncome || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Verdict & Underwriter's Comment
    doc.setFontSize(14);
    doc.text("Final Verdict & Underwriter's Comment", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Loan Decision: ${data.finalVerdict?.loanDecision || 'N/A'}`, 40, yPos);
    doc.text(`Sanction Recommendation: Rs ${data.finalVerdict?.sanctionRecommendation || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Risk Level: ${data.finalVerdict?.riskLevel || 'N/A'}`, 40, yPos);
    doc.text(`Recommended Interest: ${data.finalVerdict?.recommendedInterest || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Comments
    doc.setFontSize(14);
    doc.text("Final Comments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const comments = data.finalComments || [
      "Comprehensive analysis completed across all evaluation modules.",
      "Financial capacity and creditworthiness have been assessed.",
      "Documentation and compliance status reviewed.",
      "Final decision based on overall risk assessment and eligibility criteria."
    ];
    comments.forEach(comment => {
      doc.text(`• ${comment}`, 40, yPos);
      yPos += 15;
    });

    doc.save("final-evaluation-board-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const Section = ({ icon: Icon, title, children }) => (
  <div className="border border-gray-700 rounded-lg p-5 mb-6">
    <div className="flex items-center mb-4 text-white">
      <Icon className="w-5 h-5 text-yellow-400 mr-2" />
      <h2 className="text-lg font-semibold">{title}</h2>
    </div>
    {children}
  </div>
);

const FieldRow = ({ label, value }) => (
  <div className="flex flex-col sm:flex-row sm:justify-between text-sm text-gray-300 mb-2">
    <span className="font-medium text-white">{label}</span>
    <span>{value}</span>
  </div>
);

const ModuleBox = ({ title, value, status }) => (
  <div className="bg-[#1d1d1d] p-3 rounded-md border border-gray-700 text-sm">
    <div className="text-[#ffca20]">{title}</div>
    <div className="flex justify-between mt-1 items-center">
      <span className="text-white font-medium">{value}</span>
      <span
        className={`text-xs font-semibold ${
          status === "Good" ||
          status === "Verified" ||
          status === "Clear" ||
          status === "Strong" ||
          status === "Stable" ||
          status === "Regular"
            ? "text-green-400"
            : "text-yellow-400"
        }`}
      >
        {status}
      </span>
    </div>
  </div>
);

const FinalAnalyzer = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse || analysisResult?.analysisData || {};

  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-4 sm:p-6 text-sm space-y-6 min-h-screen max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal Evaluation Board Analyser</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
         
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Customer Profile */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          👤 Customer Master Profile
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Applicant Name</strong>
            <span className="text-white">
              {getValue("customerProfile.name") ||
                getValue("applicant.name") ||
                getValue("name")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">PAN</strong>
            <span className="text-white">
              {getValue("customerProfile.pan") ||
                getValue("applicant.pan") ||
                getValue("pan")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Aadhar</strong>
            <span className="text-white">
              {getValue("customerProfile.aadhar") ||
                getValue("applicant.aadhar") ||
                getValue("aadhar")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">DOB / Age</strong>
            <span className="text-white">
              {getValue("customerProfile.dobAge") ||
                getValue("applicant.dobAge") ||
                getValue("dobAge")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Contact Details</strong>
            <span className="text-white">
              {getValue("customerProfile.contact") ||
                getValue("applicant.phone") ||
                getValue("contact")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Loan Type Applied</strong>
            <span className="text-white">
              {getValue("loanDetails.loanType") ||
                getValue("application.loanType") ||
                getValue("loanType")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Loan Amount Requested</strong>
            <span className="text-white">
              ₹
              {(
                getValue("loanDetails.requestedAmount") ||
                getValue("application.amount") ||
                0
              ).toLocaleString("en-IN")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Employment Type</strong>
            <span className="text-white">
              {getValue("customerProfile.employmentType") ||
                getValue("applicant.employmentType") ||
                getValue("employmentType")}
            </span>
          </div>
        </div>
      </div>

      {/* Analysis Modules Overview */}
      <Section icon={ShieldCheck} title="Analysis Modules Overview">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
          <ModuleBox
            title="Credit Bureau Analysis"
            value={data.analysisModules?.creditBureau?.value || "N/A"}
            status={data.analysisModules?.creditBureau?.status || "N/A"}
          />
          <ModuleBox
            title="Bank Statement Analysis"
            value={data.analysisModules?.bankStatement?.value || "N/A"}
            status={data.analysisModules?.bankStatement?.status || "N/A"}
          />
          <ModuleBox
            title="Income & ITR Analysis"
            value={data.analysisModules?.incomeItr?.value || "N/A"}
            status={data.analysisModules?.incomeItr?.status || "N/A"}
          />
          <ModuleBox
            title="Employment Evaluation"
            value={data.analysisModules?.employment?.value || "N/A"}
            status={data.analysisModules?.employment?.status || "N/A"}
          />
          <ModuleBox
            title="Business Profile Analysis"
            value={data.analysisModules?.businessProfile?.value || "N/A"}
            status={data.analysisModules?.businessProfile?.status || "N/A"}
          />
          <ModuleBox
            title="Loan Statement Analysis"
            value={data.analysisModules?.loanStatement?.value || "N/A"}
            status={data.analysisModules?.loanStatement?.status || "N/A"}
          />
          <ModuleBox
            title="Property & Legal Documents"
            value={data.analysisModules?.propertyLegal?.value || "N/A"}
            status={data.analysisModules?.propertyLegal?.status || "N/A"}
          />
          <ModuleBox
            title="Registrations & Licenses"
            value={data.analysisModules?.registrations?.value || "N/A"}
            status={data.analysisModules?.registrations?.status || "N/A"}
          />
          <ModuleBox
            title="Agreements & Letters"
            value={data.analysisModules?.agreements?.value || "N/A"}
            status={data.analysisModules?.agreements?.status || "N/A"}
          />
        </div>
      </Section>

      {/* Final Scoring Dashboard */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <BadgeCheck size={18} /> Final Scoring Dashboard
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Credit Score Band</strong>
              <span className="text-white">
                {data.finalScoring?.creditScoreBand || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Business Viability</strong>
              <span className="text-white">
                {data.finalScoring?.businessViability || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">EMI-to-Income Ratio</strong>
              <span className="text-white">
                {data.finalScoring?.emiToIncomeRatio || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Property Title Clarity</strong>
              <span className="text-white">
                {data.finalScoring?.propertyTitleClarity || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Income Stability</strong>
              <span className="text-white">
                {data.finalScoring?.incomeStability || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Registration & Compliance
              </strong>
              <span className="text-white">
                {data.finalScoring?.registrationCompliance || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Banking Pattern</strong>
              <span className="text-white">
                {data.finalScoring?.bankingPattern || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Document Completeness</strong>
              <span className="text-white">
                {data.finalScoring?.documentCompleteness || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Validation Checklist */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <AlertCircle size={18} /> Validation Checklist
        </div>
        <div className="grid grid-cols-3 gap-4 mt-2 mb-3">
          <h4 className="text-[#AAAAAA] font-semibold">Condition</h4>
          <h4 className="text-[#AAAAAA] font-semibold">Priority</h4>
          <h4 className="text-[#AAAAAA] font-semibold">Status</h4>
        </div>
        <div className="space-y-3 mt-2">
          {(
            data.validationChecklist || [
              {
                condition: "Submit latest EC + updated property tax receipt",
                priority: "High",
                status: "Pending",
              },
              {
                condition:
                  "Resolve bank name mismatch on salary credit vs payslip",
                priority: "Medium",
                status: "Pending",
              },
              {
                condition: "Update Udyam or GST registration documents",
                priority: "Low",
                status: "Pending",
              },
            ]
          ).map((item, idx) => (
            <div key={idx} className="grid grid-cols-3 gap-4">
              <strong className="text-[#AAAAAA]">{item.condition}</strong>
              <span
                className={
                  item.priority === "High"
                    ? "text-red-500"
                    : item.priority === "Medium"
                    ? "text-yellow-400"
                    : "text-green-400"
                }
              >
                {item.priority}
              </span>
              <span className="text-white">{item.status}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Financial Summary */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <Banknote size={18} /> Financial Summary
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Monthly Net Income</strong>
            <br />
            <span className="text-green-400 text-lg">
              ₹
              {data.financialSummary?.monthlyNetIncome?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Proposed EMI</strong>
            <br />
            <span className="text-green-400 text-lg">
              ₹{data.financialSummary?.proposedEmi?.toLocaleString("en-IN") || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">EMI to Income Ratio</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.financialSummary?.emiToIncomeRatio || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Surplus Income</strong>
            <br />
            <span className="text-green-400 text-lg">
              ₹{data.financialSummary?.surplusIncome?.toLocaleString("en-IN") || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Verdict */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <CheckCircle2 size={18} /> Final Verdict & Underwriter's Comment
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Loan Decision</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.loanDecision || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Sanction Recommendation</strong>
            <br />
            <span className="text-green-400 text-lg">
              ₹
              {data.finalVerdict?.sanctionRecommendation?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Risk Level</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.riskLevel || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Recommended Interest</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.recommendedInterest || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Comments */}
      <div className="bg-green-900/20 border border-green-500 rounded-lg p-5 mt-6">
        <h2 className="text-green-400 font-semibold mb-3">Final Comments</h2>
        <ul className="list-disc list-inside text-sm text-gray-300 space-y-1">
          {data.finalComments?.map((comment, index) => (
            <li key={index}>{comment}</li>
          )) || [
            <li key="default1">
              Comprehensive analysis completed across all evaluation modules.
            </li>,
            <li key="default2">
              Financial capacity and creditworthiness have been assessed.
            </li>,
            <li key="default3">
              Documentation and compliance status reviewed.
            </li>,
            <li key="default4">
              <span className="text-green-400 font-semibold">
                Recommendation:
              </span>{" "}
              Final decision based on overall risk assessment and eligibility
              criteria.
            </li>,
          ]}
        </ul>
      </div>
    </div>
  );
};

export default FinalAnalyzer;
